// Where a NoVA citation opens. Citations are { ref, docId, title } from the
// knowledge collection; the id prefix says which surface holds the page:
//   brain-<slug>       the plane's own brain  → /admin/brain/page/<slug>
//   platform-<section> the product books      → /docs#<section>
//   anything else      an organization document → the Knowledge Platform
// A link is never a widening: the target route enforces its own access
// (/admin/brain is operators only; the module needs the org seat).
export function citationHref(c, { orgId } = {}) {
  const id = String(c?.docId || '');
  if (!id) return null;
  if (id.startsWith('brain-')) return `/admin/brain/page/${encodeURIComponent(id.slice('brain-'.length))}`;
  if (id.startsWith('platform-')) return `/docs#${encodeURIComponent(id.slice('platform-'.length))}`;
  return orgId ? `/orgs/${orgId}/knowledge` : null;
}

export function citationKind(c) {
  const id = String(c?.docId || '');
  if (id.startsWith('brain-')) return 'brain';
  if (id.startsWith('platform-')) return 'docs';
  return 'org';
}
